import React, {PropTypes} from 'react'
import i18n, {sourceIdToObj} from 'lib/i18n'
import styles from './news.scss'
const _ = i18n()

const SourcesList = ({sourceIds, customStyle}) => (
	<div className={styles.linkList}>
		{_('news_sources')}:
		{sourceIds && sourceIds.length && sourceIds.map((sourceId, i) => {
			const source = sourceIdToObj(sourceId)
			return (
				<a
					key={i}
					href={source.url}
					target="_blank"
					rel="noopener noreferrer"
				>
					{source.name}
				</a>
			)
		})}
	</div>
)
SourcesList.propTypes = {
	sourceIds: PropTypes.arrayOf(PropTypes.string),
	customStyle: PropTypes.object,
}

export default SourcesList



// WEBPACK FOOTER //
// ./elements/SourcesList.jsx